import { Typography, FormControl, InputLabel, } from "@mui/material";
import { useState } from "react";
import { Controller } from "react-hook-form";
import ReactSelect from "react-select";

type CustSelectTypeProp = {
  onFocused?: () => void, index?: number, height?: string, isEnum?: boolean, disabled?: boolean, labelName?: string, setValue?: any, label?: string, name: string, control: any, errors: any, values: Array<any>, size?: number, isMulti?: boolean, onHandleChnage?: (e: any, i?: number) => void
}

const CustomSelect = ({ onFocused, index, height = '40px', isEnum, labelName, setValue, label, name, control, errors, values, size = 4, isMulti = false, onHandleChnage, disabled = false }: CustSelectTypeProp) => {

  const [focused, setFocused] = useState(false);

  const convertedValues = values.map((val: any) => {
    return { value: val.value ?? val.id, label: val.label ?? val.title ?? val.name ?? val.lockerNumber }
  })

  const ReactSelectStyles = {
    control: (provided: any, state: { isFocused: any; }) => ({
      ...provided,
      border: label || height ? "solid 1px #9e9e9e" : 'none',
      background: '#fff',
      borderColor: '#9e9e9e',
      minHeight: '30px',
      height: label ? height ? height : '2.5rem' : '1.5rem',
      boxShadow: state.isFocused ? null : null,
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      // zIndex: '15 !important',
    }),

    valueContainer: (provided: any, state: any) => ({
      ...provided,
      height: label ? height ? height : '2.5rem' : '1.5rem',
      padding: '0 12px',
    }),

    input: (provided: any, state: any) => ({
      ...provided,
      margin: '0',

    }),
    indicatorSeparator: (state: any) => ({
      display: 'none',
    }),
    indicatorsContainer: (provided: any, state: any) => ({
      ...provided,
      height: label ? height ? height : '2.5rem' : '1.5rem',
    }),
    menu: (provided: any, state: any) => ({
      ...provided,
      zIndex: '5 !important',
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
    }),
  };

  const handleFocus = () => {
    onFocused?.()
    setFocused(true);
  };

  const handleBlur = () => {
    setFocused(false);
  };

  return (
    <div style={{ position: 'relative' }}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (<FormControl sx={{ width: "100%" }} >
          {label ? <InputLabel id={name} shrink={focused || !!field.value || (isEnum && (field?.value || field?.value === 0))} style={{ background: 'white', padding: '0px 6px', top: height ? (focused || !!field.value || (isEnum && (field?.value || field?.value === 0))) ? '0' : '-8px' : '0px' }}>{`${label}`}</InputLabel> : null}
          <ReactSelect
            isDisabled={disabled}
            isMulti={isMulti}
            isClearable={label ? true : false}
            {...field}
            options={convertedValues}
            styles={ReactSelectStyles}
            placeholder={''}
            value={field?.value === 0 && !isEnum ? "" : convertedValues.find((c) => c.value === field.value)}
            onChange={(e: any) => {
              if (e?.value || (isEnum && (e?.value || e?.value === 0))) {
                if (labelName) {
                  setValue(labelName, e.label)
                }
                if (onHandleChnage) {
                  onHandleChnage(e, index)
                }
                field.onChange(e.value)
              }
              if (isMulti && onHandleChnage) {
                onHandleChnage(e)
              }
            }}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
        </FormControl>
        )}
      />
      {errors ? <Typography mt={1} ml={2} sx={{ position: 'absolute', bottom: '-18px', color: "#DD2F30", fontSize: "12px" }}>{errors}</Typography> : null}
    </div>
  )
}

export default CustomSelect;
